<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
    <mat-card class="p-0">
        <form [formGroup]="doctoRefForm"  *ngIf="doctoRefForm">
            <div fxLayout="row wrap"  >
                <div fxFlex="100" class="pr-1"><br></div>
                <div fxFlex="100" fxFlex.gt-sm="100" fxFlex.sm="35">
                    <mat-form-field class="full-width">
                        <mat-label>Tipo de Documento</mat-label>
                        <mat-select  tabIndex="1" [formControl]="doctoRefForm.controls['nfeRefDocumento']" >
                            <mat-option *ngFor="let tipo of tipoDoctoRef" [value]="tipo?.descricao">
                                {{tipo.descricao.trim()}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="100" fxFlex.sm="35">
                    <mat-form-field class="full-width">
                        <input [imask]="this.maskOnlyNumeric"   matInput name="chaveAcesso" type="text"                        
                        [formControl]="doctoRefForm.controls['nfeRefChaveAcesso']!" placeholder="Chave de acesso"
                         (focus)="$event.target.select()">
                      </mat-form-field>
                      <small *ngIf="doctoRefForm.controls['nfeRefChaveAcesso'].hasError('required') && doctoRefForm.controls['nfeRefChaveAcesso'].touched"
                        class="form-error-msg"> Chave de acesso é obrigatório </small>
                </div>
                              
                <div fxFlex="50" fxFlex.gt-sm="100" fxFlex.sm="30">
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>Emissão</mat-label>
                        <input matInput [matDatepicker]="picker" [formControl]="doctoRefForm.controls['nfeRefEmissao']">
                        <mat-hint>DD/MM/YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker  startView="month" [startAt]="startDate"></mat-datepicker>
                      </mat-form-field>
                      

                      <!-- <mat-form-field  class="mx-auto">
                        <input matInput name="validade" matInput type="date" [formControl]="doctoRefForm.controls['validadePromocao']!"
                          placeholder="Validade" (focus)="$event.target.select()">
                      </mat-form-field> -->
                </div>
                  <div fxFlex="50" class="pr-1" *ngIf="this.ref.fatDoctoC.serie.serieModelo==='57'">
                    <mat-form-field class="full-width">
                      <mat-label>Expedidor do CT-e Anterior</mat-label>
                      <mat-select [formControl]="doctoRefForm?.controls['nfeRefCadCadastro']!" (selectionChange)="onSelectionChangeNfeRefCadCadastro($event)">
                        <mat-option>
                          <ngx-mat-select-search [formControl]="doctoRefForm?.controls['searchNfeRefCadCadastro']!" placeholderLabel="Pesquisar Expedidor."
                            noEntriesFoundLabel="Expedidor não encontrado" [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let d of cadastros" [value]="d">
                          <span>{{ d?.razaoSocial + " - "  }}</span>
                          <span *ngIf="d?.tipoPessoa === 'Fisica'">{{"CPF:"+d?.cpf }}</span>
                          <span *ngIf="d?.tipoPessoa !== 'Fisica'">{{ "CNPJ:"+d?.inscricaoFederal }}</span>
                          <span>{{" [ " + d?.cadMun?.municipio +"/"+ d?.cadMun?.uf +" ]"}}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <small
                      *ngIf="doctoRefForm.controls['nfeRefCadCadastro'].hasError('required') && doctoRefForm.controls['nfeRefCadCadastro'].touched"
                      class="form-error-msg"> Expedidor é  obrigatório </small>
                  </div>

                  <div fxFlex="50" class="pr-1">
                    <mat-form-field class="full-width">
                      <mat-label>Cidade</mat-label>
                      <mat-select [formControl]="doctoRefForm?.controls['cadMun']!" (selectionChange)="onSelectionChange($event)">
                        <mat-option>
                          <ngx-mat-select-search [formControl]="doctoRefForm?.controls['searchCidade']!"
                            placeholderLabel="Pesquisar Cidade.." noEntriesFoundLabel="Cidade não encontrada"
                            [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let cadMun of cidades" [value]="cadMun">
                          <span>{{ cadMun?.municipio?.trim() }} - </span>
                          <span> {{cadMun?.uf?.trim()}}</span>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                
            </div>
        </form>
    </mat-card>
</div>
<mat-dialog-actions>
    <div fxFlex="100" class="mt-1">
        <button class="mb-8" mat-raised-button [matTooltip]="'Salvar'" color="primary"
            (click)="this.save();$event.preventDefault();">
            <mat-icon>save</mat-icon>{{"SAVE" |
            translate }}
        </button>
        <span fxFlex></span>
        <button mat-button color="warn" type="button" (click)="close()">
            <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
        </button>
    </div>
</mat-dialog-actions>